import styles from '../static.module.scss';

/**
 * Страница правил бонусной программы
 * @returns {JSX.Element}
 */
const BonusProgramRegulationPage: React.FC = () => (
    <div className={styles.paper}>
        <h2 className={styles.title}>Правила бонусной программы</h2>
        <h6 className={styles.chapter}>1. Общая информация о бонусной программе</h6>
        <p>
            Бонусная Программа "Подзамену" - это программа, позволяющая покупателю (Участнику программы)
            получать бонусы за покупки и использовать их в дальнейшем в качестве скидки при приобретении товаров,
            покупаемых в магазинах "Подзамену" (в том числе и интерент-магазине podzamenu.ru).
        </p>
        <p>Участие в Бонусной Программе позволяет:</p>
        <ul>
            <li>
                Получать и накапливать бонусы за совершаемые покупки.
            </li>
            <li>
                При приобретении товара получать скидку на количество накопленных бонусов.
                При этом, максимальный размер скидки составляет 10% от стоимости товара.
            </li>
            <li>
                Получать предложения, информацию о скидках и акциях, проводимых в магазинах «Подзамену» и на сайте:
                podzamenu.ru
            </li>
        </ul>
        <h6 className={styles.chapter}>2. Термины</h6>
        <ul>
            <li>
                Бонусный Счёт Участника — персональный счёт, открываемый Оператором в своей информационной системе на
                имя
                Участника в соответствии с настоящими Правилами для начисления и списания Бонусов.
                Бонусы начисляются на Счёт и списываются с него в соответствии с Правилами. Информация об операциях
                начисления на
                Счёт и списания со Счёта Бонусов, актуальном состоянии Счёта доступна Участнику в Личном кабинете.
                Бонусный Счет привязывается к мобильному номеру телефону клиента, который является его уникальным
                идентификатором.
            </li>
            <li>
                Личный кабинет — персональная страница Участника на сайте Программы podzamenu.ru, на которой содержится
                информация об Участнике, о балансе Бонусного Счета, а также информация о движении Бонусов на Счете:
                поступлении и списании.
            </li>
            <li>
                Правила Программы – правила, регламентирующие порядок работы Бонусной Программы, условия участия в ней и
                условия получения скидок на товары.
            </li>
            <li>
                Оператор Программы — ИП Колесниченко Александр Николаевич ("Подзамену"), юридический адрес: г.
                Владивосток, ул. Снеговая, д. 4, офис 6.
            </li>
            <li>
                Участник — физическое лицо, достигшее возраста 18 лет, покупатель магазина Оператора, зарегистрированный
                в
                Программе в соответствии с настоящими Правилами. Участник вправе управлять своим Бонусным Счетом
                самостоятельно (накапливать / списывать Бонусы).
            </li>
            <li>
                Бонус – скидка, предоставляемая Компанией (Оператором Программы) Участнику в соответствии с настоящими
                Правилами Программы,
                которая может быть использована при оплате покупки в розничных магазинах, и на сайте интернет-магазина
                podzamenu.ru.
                Сумма начисленных Бонусов может быть использована Участником для получения скидки в соответствии с
                настоящими Правилами.
                Бонусы не являются денежными единицами, обмену на денежные средства не подлежат, а используются только в
                рамках
                Программы в соответствии с ее условиями. Бонусами можно оплатить часть очередной покупки (не более 10%
                стоимости товара)
                из расчета 1 Бонус = 1 рубль. Срок действия Бонусов составляет 120 дней с момента их активации, на 121
                день неиспользуемые Бонусы обнуляются.
            </li>
            <li>
                Промо Бонусы - Бонусы, имеющие ограниченный срок действия - 14 дней, начисляемые Участникам в рамках
                специальных акций,
                проводимых Оператором. Промо Бонусы, не используемые Участником в течение 14 дней с момента их
                начисления, обнуляются.
            </li>
            <li>
                Неактивные Бонусы – Бонусы, начисленные на Бонусный Счет Участника за совершенные покупки и недоступные
                для использования.
            </li>
            <li>
                Доступные Бонусы – Бонусы, доступные для использования при оплате покупок. Недоступные Бонусы
                активируются и переходят в статус
                Доступные спустя 14 дней с момента выдачи заказа клиенту или в транспортную компанию.
            </li>
            <li>
                Резерв – Бонусы, которые зарезервированы для оплаты оформленных заказов на Сайте интернет-магазина
                podzamenu.ru или в розничных магазинах
                Оператора Программы.
            </li>
        </ul>
        <h6 className={styles.chapter}>3. Персональные данные участника</h6>
        <ul>
            <li>
                Участник гарантирует точность и достоверность предоставленных им данных, а также то,
                что указанные, внесённые им данные являются именно его данными, а не данными третьего лица.
            </li>
            <li>
                Зарегистрированный Участник обязуется своевременно вносить изменения в свои данные в
                Личном кабинете Программы либо предоставлять их Оператору.
            </li>
            <li>
                Оператор не отвечает за достоверность и точность предоставляемых Участником данных,
                а также за последствия предоставления Участником неточных и недостоверных данных,
                а также данных третьих лиц.
            </li>
            <li>
                Добровольно предоставляя персональные, контактные данные, Участник подтверждает своё согласие на сбор,
                хранение, использование, обработку и распространение данных для целей Программы.
            </li>
            <li>
                Оператор гарантирует необходимые меры защиты данных от несанкционированного разглашения
                в соответствии с Политикой в отношении обработки персональных данных.
            </li>
        </ul>
        <h6 className={styles.chapter}>4. Правила программы</h6>
        <ul>
            <li>
                Бонусная Программа является накопительной и предполагает начисление Бонусов за совершенные покупки,
                которые можно использовать в счет частичной оплаты последующих покупок в магазинах "Подзамену".
            </li>
            <li>
                Настоящие Правила Бонусной Программы (далее Правила) определяют условия участия в Программе клиентов
                компании
                "Подзамену" на всей территории России. Правила Программы регламентируют основные положения и принципы
                функционирования Программы.
            </li>
            <li>
                Каждый клиент (только физическое лицо) компании "Подзамену" имеет право на получение бонусов за покупки
                для получения скидки на последующие покупки. Использование скидки клиентом по Бонусной Программе при
                очередной покупке означает его безоговорочное согласие с принятием правил Бонусной Программы компании
                "Подзамену".
            </li>
            <li>
                Вступая в Бонусную Программу, Участник подтверждает свое согласие с ее условиями и разрешает хранение,
                передачу и обработку своих персональных данных, которые он сообщит компании Оператору Программы.
                А также участник Программы подтверждает свое согласие на получение рассылок по электронной почте и смс
                от компании Оператора Программы.
            </li>
            <li>
                В Правила могут вноситься изменения Оператором в любое время с обязательной публикацией изменений на
                сайте
                podzamenu.ru, без предварительного уведомления участников Программы.
            </li>
            <li>
                Действие программы может быть прекращено Оператором в одностороннем порядке с предварительным
                уведомлением Участников
                Программы за 7 (семь) дней до даты прекращения программы на сайте Оператора программы podzamenu.ru.
            </li>
            <li>
                Участник вправе прекратить участие в Программе в любое время путем направления Оператору письменного
                уведомления
                по электронной почте (адрес: bonus@podzamenu.ru) о прекращении участия. Участие соответствующего
                Участника в
                Программе будет считаться прекращенным с момента получения Оператором уведомления Участника.
            </li>
            <li>
                Оператор вправе в любое время в одностороннем порядке прекратить участие в Программе любого Участника
                без предупреждения по любой причине.
            </li>
            <li>
                Программа действует с момента ее запуска и до полной ее отмены по решению Оператора Программы.
            </li>
            <li>
                По всем вопросам бонусной программы обращайтесь по адресу bonus@podzamenu.ru.
            </li>
        </ul>
        <h6 className={styles.chapter}>5. Начисление бонусов</h6>
        <ul>
            <li>
                Начисление Бонусов производится при любом способе оформления заказа клиентом, при котором Оператору
                Программы вместе с заказом передается номер мобильного телефона клиента.
            </li>
            <li>
                Бонусы начисляются на Бонусный Счет клиента в течение суток с момента полной оплаты заказа,
                но имеют статус Неактивные. Бонусы активируются (получают статус Доступные) в течение 14 календарных
                дней с даты выдачи заказа клиенту или в транспортную компанию.
            </li>
            <li>
                Размер начислений составляет 3% от стоимости товаров в заказе.
            </li>
            <li>
                Бонусы зачисляются на Бонусный Счет исходя из суммы, фактически оплаченной клиентом рублями за заказ (за
                вычетом суммы оплаты Бонусами).
            </li>
            <li>
                Промо Бонусы начисляются Участникам Оператором программы по своему усмотрению, становятся доступными
                для использования Участниками с момента зачисления на Бонусный Счет.
            </li>
            <li>
                При возврате товара, частично оплаченного Бонусами, Бонусы, которыми был оплачен возвращаемый товар,
                будут возвращены на Бонусный счет Участника. Сумма Бонусов, подлежащая возврату, рассчитывается от суммы
                Бонусов,
                которыми был оплачен заказ, пропорционально стоимости возвращаемого товара.
            </li>
            <li>
                Срок действия Доступных Бонусов на Бонусном Счете Участника Программы автоматически продлевается на 120
                дней
                с момента зачисления на его Бонусный счет Бонусов с его очередной покупки.
            </li>
        </ul>
        <h6 className={styles.chapter}>6. Списание бонусов</h6>
        <ul>
            <li>
                Участники Бонусной Программы могу потратить Бонусы, полученные ранее за покупку товаров,
                для получения скидки на очередную покупку с момента их активации, т.е. через 14 дней с момента выдачи
                ранее купленного заказа Участнику или передачи заказа в транспортную компанию.
            </li>
            <li>
                Для использования Бонусов Участнику Программы необходимо создать заказ, находясь на сайте podzamenu.ru,
                предварительно пройдя процедуру авторизации на нем (ввести логин и пароль своей учетной записи),
                или назвать менеджеру компании Оператора Бонусной Программы номер мобильного телефона - идентификатор
                Участника при оформлении заказа, при этом уведомив его о своем желании списать накопленные Бонусы в счет
                Скидки на приобретение товаров.
            </li>
            <li>
                Участники могут использовать Бонусы для получения скидки до 10% стоимости очередной покупки.
            </li>
            <li>
                Участники могут тратить накопленные ранее Бонусы для получения скидки на покупку любых товаров в
                магазинах Оператора Программы.
            </li>
            <li>
                Бонусы не могут быть использованы Участниками Программы для получения скидки на покупку товаров в
                кредит, а также подарочных сертификатов.
            </li>
            <li>
                Бонусы для списания за каждый товар распределяются пропорционально стоимости каждого товара.
            </li>
            <li>
                При подтверждении заказа сумма Бонусов к списанию будет зарезервирована до тех пор, пока Участник не
                оплатит
                заказ или резерв Бонусов не будет снят менеджером компании Оператора. При этом Участнику будет
                недоступна
                возможность использовать Бонусы для оплаты других заказов, пока часть или все его Бонусы будут в
                резерве.
            </li>
            <li>
                При возврате товара Бонусы, начисленные за покупку возвращаемого товара, будут списаны с Бонусного счета
                Участника.
            </li>
            <li>
                При наличии у Участника на Бонусном Счете Бонусов, а также Промо Бонусов, начисленных в рамках акций
                Оператора Программы,
                в счет скидки при очередной покупке сначала списываются Промо Бонусы, затем Бонусы.
            </li>
            <li>
                Фактическое списание Бонусов при оплате покупки. При покупке в розничном магазине Оператора, фактическое
                списание
                Бонусов происходит сразу после оплаты заказа на кассе. В случае получения товара с доставкой или при
                оплате товара
                на сайте интернет-магазина списание Бонусов произойдет в течение 1 (одних) суток с момента оплаты.
            </li>
        </ul>
    </div>
);

export default BonusProgramRegulationPage;
